// import React, { useState } from 'react'
// import { Link } from 'react-router-dom'
// import "./Sidebar.css"
// import { useDispatch, useSelector } from 'react-redux'
// import { setSidebar } from '../../Redux Store/Slice';

// function Sidebar() {
//     let sidebar_status = useSelector(state => state.appstate.sidebar)
//     let dispatch = useDispatch();

//     // State for managing which category is open
//     const [openCategory, setOpenCategory] = useState('featured');
//     const [activeTab, setActiveTab] = useState('women');

//     const handleOverlayClick = () => {
//         dispatch(setSidebar(false));
//     };

//     const handleCategoryClick = (category) => {
//         if (openCategory === category) {
//             setOpenCategory(null); // Close if already open
//         } else {
//             setOpenCategory(category); // Open new category, close others
//         }
//     };

//     const handleTabClick = (tab) => {
//         setActiveTab(tab);
//     };

//     return (
//         <>
//             {/* Shadow Overlay */}
//             {sidebar_status && (
//                 <div
//                     className="sidebar-overlay"
//                     onClick={handleOverlayClick}
//                 ></div>
//             )}

//             {/* Sidebar */}
//             <aside className="sidebar" style={{left: sidebar_status ? '0' : "-100%"}}>
//                 <div className="search-bar">
//                     <input type="text" placeholder="Search for..." />
//                     <button onClick={() => {
//                         dispatch(setSidebar(false));
//                     }}>✕</button>
//                 </div>

//                 <div className="nav-tabs">
//                     <button
//                         className={activeTab === 'women' ? 'active' : ''}
//                         onClick={() => handleTabClick('women')}
//                     >
//                         WOMEN
//                     </button>
//                     <button
//                         className={activeTab === 'men' ? 'active' : ''}
//                         onClick={() => handleTabClick('men')}
//                     >
//                         MEN
//                     </button>
//                 </div>

//                 <div className={`menu-section ${openCategory === 'featured' ? 'expanded' : 'collapsible'}`}>
//                     <div className="section-header" onClick={() => handleCategoryClick('featured')}>
//                         <h4>FEATURED</h4>
//                         <span className="caret">{openCategory === 'featured' ? '▲' : '▼'}</span>
//                     </div>
//                     <ul>
//                         <li><Link to="/collections">New Releases</Link></li>
//                         <li><Link to="/collections">Bestsellers</Link></li>
//                         <li><Link to="/collections">Courtside</Link></li>
//                         <li><Link to="/collections">Summer Fits</Link></li>
//                         <li><Link to="/collections">Black Leggings</Link></li>
//                         <li><Link to="/collections">Essential Sports Bras</Link></li>
//                     </ul>
//                 </div>

//                 <div className={`menu-section ${openCategory === 'category' ? 'expanded' : 'collapsible'}`}>
//                     <div className="section-header" onClick={() => handleCategoryClick('category')}>
//                         <h4>SHOP BY CATEGORY</h4>
//                         <span className="caret">{openCategory === 'category' ? '▲' : '▼'}</span>
//                     </div>
//                     <ul>
//                         <li><Link to="/collections">Leggings</Link></li>
//                         <li><Link to="/collections">Sports Bras</Link></li>
//                         <li><Link to="/collections">Tops</Link></li>
//                         <li><Link to="/collections">Shorts</Link></li>
//                         <li><Link to="/collections">Jackets</Link></li>
//                     </ul>
//                 </div>

//                 <div className={`menu-section ${openCategory === 'collection' ? 'expanded' : 'collapsible'}`}>
//                     <div className="section-header" onClick={() => handleCategoryClick('collection')}>
//                         <h4>SHOP BY COLLECTION</h4>
//                         <span className="caret">{openCategory === 'collection' ? '▲' : '▼'}</span>
//                     </div>
//                     <ul>
//                         <li><Link to="/collections">Core Collection</Link></li>
//                         <li><Link to="/collections">Limited Edition</Link></li>
//                         <li><Link to="/collections">Seasonal</Link></li>
//                     </ul>
//                 </div>

//                 <div className={`menu-section ${openCategory === 'accessories' ? 'expanded' : 'collapsible'}`}>
//                     <div className="section-header" onClick={() => handleCategoryClick('accessories')}>
//                         <h4>ACCESSORIES</h4>
//                         <span className="caret">{openCategory === 'accessories' ? '▲' : '▼'}</span>
//                     </div>
//                     <ul>
//                         <li><Link to="/collections">Bags</Link></li>
//                         <li><Link to="/collections">Water Bottles</Link></li>
//                         <li><Link to="/collections">Hair Accessories</Link></li>
//                     </ul>
//                 </div>

//                 <div className="bottom-links">
//                     <ul>
//                         <li><Link to="/collections">Account</Link></li>
//                         <li><Link to="/collections">Help Center</Link></li>
//                         <li><Link to="/collections">Shipping Information</Link></li>
//                         <li><Link to="/collections">Returns Policy</Link></li>
//                     </ul>
//                 </div>
//             </aside>
//         </>
//     )
// }

// export default Sidebar

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Sidebar.css";
import { useDispatch, useSelector } from "react-redux";
import { setSidebar } from "../../Redux Store/Slice";
import axios from "axios";

function Sidebar() {
    let sidebar_status = useSelector((state) => state.appstate.sidebar);
    let dispatch = useDispatch();
    let base_url = process.env.REACT_APP_BACKEND_URL;

    const [sidebarData, setSidebarData] = useState([]); // API result
    const [openCategory, setOpenCategory] = useState(null);
    const [activeTab, setActiveTab] = useState("Women"); // Default to Women

    // Fetch Sidebar Data from API
    useEffect(() => {
        axios
            .get(`${base_url}/admin/sidebar/sidebar`)
            .then((res) => {
                setSidebarData(res.data.sidebar);
            })
            .catch((err) => console.error("Sidebar fetch error:", err));
    }, []);

    const handleOverlayClick = () => {
        dispatch(setSidebar(false));
    };

    const handleCategoryClick = (categoryId) => {
        setOpenCategory(openCategory === categoryId ? null : categoryId);
    };

    const handleTabClick = (tabTitle) => {
        setActiveTab(tabTitle);
        setOpenCategory(null); // Reset open category when switching tabs
    };

    // Find active tab data
    const currentTab = sidebarData?.find((tab) => tab.title === activeTab) || {
        sections: [],
    };

    return (
        <>
            {sidebar_status && (
                <div
                    className="sidebar-overlay"
                    onClick={handleOverlayClick}
                ></div>
            )}

            <aside
                className="sidebar"
                style={{ left: sidebar_status ? "0" : "-200%" }}
            >
                {/* Search */}
                <div className="search-bar">
                    <input type="text" placeholder="Search for..." />
                    <button onClick={() => dispatch(setSidebar(false))}>
                        ✕
                    </button>
                </div>

                {/* Tabs */}
                <div className="nav-tabs">
                    {sidebarData.map((tab) => (
                        <button
                            key={tab.tab_id}
                            className={activeTab === tab.title ? "active" : ""}
                            onClick={() => handleTabClick(tab.title)}
                        >
                            {tab.title.toUpperCase()}
                        </button>
                    ))}
                </div>

                {/* Sections */}
                {currentTab?.sections?.map((section) => (
                    <div
                        key={section.id}
                        className={`menu-section ${openCategory === section.id ? "expanded" : "collapsible"}`}
                    >
                        <div
                            className="section-header"
                            onClick={() => handleCategoryClick(section.id)}
                        >
                            <h4>{section.title}</h4>
                            <span className="caret">
                                {openCategory === section.id ? "▲" : "▼"}
                            </span>
                        </div>
                        <ul>
                            {section.links.map((link) => (
                                <li key={link.id}>
                                    <Link to={link.url}>{link.label}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}

                {/* Static bottom links */}
                <div className="login-btn">
                    <Link to="/login">Login</Link>
                </div>
                <div className="bottom-links">
                    <ul>
                        <li>
                            <Link to="/account">Account</Link>
                        </li>
                        <li>
                            <Link to="/help">Help Center</Link>
                        </li>
                        <li>
                            <Link to="/shipping">Shipping Information</Link>
                        </li>
                        <li>
                            <Link to="/returns">Returns Policy</Link>
                        </li>
                    </ul>
                </div>
            </aside>
        </>
    );
}

export default Sidebar;
